import React from 'react';
import { Phone, MapPin, Clock, Mail } from 'lucide-react';
import { Button } from './ui/button';
import { companyInfo } from '../utils/mockData';

const Contact = () => {
  const whatsappNumber = "5585985195369";
  const whatsappMessage = "Olá! Gostaria de solicitar um orçamento.";
  const whatsappLink = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(whatsappMessage)}`;

  return (
    <section id="contato" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          {/* Section Header */}
          <div className="text-center mb-12">
            <div className="inline-block mb-4 px-4 py-2 bg-[#1e3a8a]/10 rounded-full">
              <p className="text-[#1e3a8a] text-sm font-semibold">CONTATO</p>
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
              Fale Conosco
            </h2>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto">
              Entre em contato e solicite seu orçamento sem compromisso
            </p>
          </div>

          {/* Contact Cards */}
          <div className="grid md:grid-cols-2 gap-6 mb-12">
            {/* WhatsApp Card */}
            <div className="bg-gradient-to-br from-[#25D366]/10 to-[#25D366]/5 border-2 border-[#25D366]/30 rounded-xl p-8 hover:shadow-xl transition-all duration-300 hover:-translate-y-1">
              <div className="flex items-center mb-4">
                <div className="w-14 h-14 bg-[#25D366] rounded-lg flex items-center justify-center mr-4">
                  <Phone className="w-7 h-7 text-white" />
                </div>
                <div>
                  <h3 className="font-semibold text-gray-900 text-lg">WhatsApp</h3>
                  <p className="text-sm text-[#25D366] font-semibold">✅ Online agora - Resposta em minutos!</p>
                </div>
              </div>
              <p className="text-2xl font-bold text-gray-900 mb-4">
                {companyInfo.phone}
              </p>
              <Button 
                onClick={() => window.open(whatsappLink, '_blank')}
                className="bg-[#25D366] hover:bg-[#20BD5C] text-white font-semibold w-full shadow-lg hover:shadow-xl transition-all"
              >
                Chamar no WhatsApp AGORA
              </Button>
            </div>

            {/* Address Card */}
            <div className="bg-gradient-to-br from-[#1e3a8a]/10 to-[#3b82f6]/5 border-2 border-[#1e3a8a]/30 rounded-xl p-8 hover:shadow-xl transition-all duration-300 hover:-translate-y-1">
              <div className="flex items-center mb-4">
                <div className="w-14 h-14 bg-[#1e3a8a] rounded-lg flex items-center justify-center mr-4">
                  <MapPin className="w-7 h-7 text-white" />
                </div>
                <div>
                  <h3 className="font-semibold text-gray-900 text-lg">Endereço</h3>
                  <p className="text-sm text-gray-600">Visite nossa loja</p>
                </div>
              </div>
              <p className="text-gray-700 mb-4 leading-relaxed">
                {companyInfo.address}
              </p>
            </div>
          </div>

          {/* Hours */}
          <div className="bg-gradient-to-r from-gray-50 to-white border border-gray-200 rounded-xl p-8 text-center">
            <div className="flex items-center justify-center mb-4">
              <div className="w-14 h-14 bg-gradient-to-br from-[#f97316] to-[#fb923c] rounded-lg flex items-center justify-center">
                <Clock className="w-7 h-7 text-white" />
              </div>
            </div>
            <h3 className="font-semibold text-gray-900 text-xl mb-2">Horário de Atendimento</h3>
            <p className="text-gray-700 text-lg">
              {companyInfo.hours}
            </p>
          </div>

          {/* CTA Section */}
          <div className="mt-12 bg-gradient-to-r from-[#1e3a8a] to-[#3b82f6] rounded-2xl p-8 md:p-12 text-center text-white">
            <h3 className="text-3xl md:text-4xl font-bold mb-4">
              Precisa Agora? A Gente Resolve Hoje!
            </h3>
            <p className="text-xl text-white/90 mb-8 max-w-2xl mx-auto">
              Chame no WhatsApp e receba atendimento imediato. Orçamento grátis em minutos!
            </p>
            <Button 
              onClick={() => window.open(whatsappLink, '_blank')}
              size="lg"
              className="bg-[#25D366] hover:bg-[#20BD5C] text-white font-semibold px-10 py-6 text-lg shadow-2xl hover:shadow-[#25D366]/50 transition-all hover:scale-105"
            >
              <Phone className="w-5 h-5 mr-2" />
              Pedir Orçamento GRÁTIS Agora
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
